export * from './GlobalStyle';
//# sourceMappingURL=index.js.map